import React from 'react';
function HomeOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M12 5.69l5 4.5V18h-2v-6H9v6H7V10.19l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z" })));
}
export default HomeOutlined;
